import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { marcarLido } from '../../../actions';

const renderProfileImage = ({ remetente }) => {
  if (remetente && 'foto' in remetente && remetente.foto)
    return <img src={remetente.foto} alt="Avatar" className="avatar" />;

  const nomeRemetente = remetente ? remetente.nome : 'Tron Box';

  return <div className="no-profile avatar">{nomeRemetente.charAt(0)}</div>;
};

const NotificacaoItem = ({ history, item, marcarLidoAction }) => {
  const isNova = item.lidoEm === 0 || !('lidoEm' in item);

  return (
    <div
      onKeyPress={null}
      role="button"
      tabIndex="0"
      className={`notificacao-item ${isNova ? 'nova-notificacao' : ''}`}
      onClick={() => history.push(item.resourcePath)}
    >
      <div className="avatar-container">{renderProfileImage(item)}</div>
      <div className="msg-container">
        <span>{item.mensagem}</span>
        <div className="notificacao-data">
          <div>{moment.unix(item.enviadoEm).fromNow()}</div>
          {isNova && (
            <div
              onKeyPress={null}
              role="button"
              tabIndex="0"
              className="dot"
              data-toggle="tooltip"
              data-placement="top"
              title="Marcar como lido"
              onClick={(e) => {
                e.stopPropagation();
                marcarLidoAction(item.id);
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default withRouter(
  connect(
    null,
    { marcarLidoAction: marcarLido },
  )(NotificacaoItem),
);
